import axios from "@/utils/axios.ts";
import type { CreateMember, UpdateMember } from "./type";

export const getMemberList = async (params: {
  offset: number;
  count: number;
  sort_by: string | undefined;
  order: "ASC" | "DESC";
  filter: Record<string, string | number> | undefined;
}) => {
  const response = await axios.post("/api/member/get_list", {
    offset: params.offset,
    count: params.count,
    sort_by: params.sort_by,
    order: params.order,
    filter: params.filter,
  });
  return response.data.members;
};

export const getMemberCount = async () => {
  const response = await axios.post("/api/member/get_count");
  return response.data.count;
};

export const getMemberDetail = async (id: number) => {
  const response = await axios.post("/api/member/get_by_id", {
    member_id: id,
  });
  return response.data.member;
};

export const checkUniqueCheckinCode = async (code: number) => {
  const response = await axios.post<{
    is_unique: boolean;
  }>("/api/member/check_code_unique", {
    checkin_code: code,
  });
  return response.data;
};

export const checkUniqueEmail = async (email: string) => {
  const response = await axios.post<{
    is_unique: boolean;
  }>("/api/member/check_email_unique", {
    email,
  });
  return response.data;
};

export const createMember = async (member: CreateMember) => {
  const response = await axios.post("/api/member/create", {
    new_member_info: member.new_member_info,
  });
  return response.data;
};

export const updateProfile = async ({
  image,
  memberId,
}: {
  image: File;
  memberId: number;
}) => {
  const formData = new FormData();
  formData.append("image", image);
  formData.append("member_id", memberId.toString());

  const response = await axios.post(
    "/api/member/update_profile_image",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const updateMember = async (member: UpdateMember) => {
  const response = await axios.post("/api/member/update", {
    member_id: member.member_id,
    member_info: member.member_info,
  });
  return response.data;
};

export const deleteMember = async (id: number) => {
  const response = await axios.post("/api/member/delete", {
    member_id: id,
  });
  return response.data;
};
